import React from "react";
import { Paper, Typography, Stack } from "@mui/material";

export interface EraEobSummaryCounts {
  numberOfERAs?: number;
  numberOfEOBs?: number;
  numberOfMappedEOBs?: number;
  numberOfUnmappedEOBs?: number;
  numberOfSuccessfulPayments?: number;
  numberOfPaymentFailures?: number;
}

interface EraEobSummaryCardsProps {
  counts: EraEobSummaryCounts;
  onCardClick?: (cardKey: string) => void;
  activeCard?: string | null;
}

const SUMMARY_CARDS = [
  {
    key: "numberOfERAs",
    label: "# of ERAs",
    highlight: false,
  },
  {
    key: "numberOfEOBs",
    label: "# of EOBs",
    highlight: false,
  },
  {
    key: "numberOfMappedEOBs",
    label: "# of Mapped EOBs",
    highlight: false,
  },
  {
    key: "numberOfUnmappedEOBs",
    label: "# of Un-mapped EOBs",
    highlight: true,
    highlightColor: "#FF0000",
  },
  {
    key: "numberOfSuccessfulPayments",
    label: "# of Successful Payments",
    highlight: false,
  },
  {
    key: "numberOfPaymentFailures",
    label: "# of Payments Failuers",
    highlight: true,
    highlightColor: "#FF0000",
  },
];

const EraEobSummaryCards: React.FC<EraEobSummaryCardsProps> = ({
  counts,
  onCardClick,
  activeCard,
}) => {
  return (
    <Stack direction="row" spacing={2} width="100%" mb={1.5} flexWrap="wrap">
      {SUMMARY_CARDS.map((card, ind) => {
        const isActive = activeCard === card.key;
        const count = counts[card.key as keyof EraEobSummaryCounts] ?? 0;
        const isHighlighted = card.highlight && count > 0;

        return (
          <Paper
            key={card.key}
            elevation={0}
            sx={{
              flex: "1 1 calc(16.66% - 16px)",
              minWidth: 180,
              bgcolor: "#FFFFFF",
              borderRadius: 2,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
              p: 1,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: 80,
              border: isActive ? "2px solid #315095" : "1px solid #E0E0E0",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                transform: "translateY(2px)",
              },
            }}
            onClick={() => onCardClick && onCardClick(card.key)}
          >
            <Typography
              variant="h5"
              fontWeight={700}
              color={isHighlighted ? card.highlightColor : "#373D41"}
              sx={{
                fontSize: 24,
                lineHeight: 1.2,
              }}
            >
              {ind === 0 || ind === 1 ? count : 0}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={500}
              color="#595F63"
              sx={{
                fontSize: 14,
                lineHeight: 1.4,
                mb: 1,
              }}
            >
              {card.label}
            </Typography>
          </Paper>
        );
      })}
    </Stack>
  );
};

export default EraEobSummaryCards;
